var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationHeartFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12 2.5c-4.687 0-8.5 3.813-8.5 8.5 0 4.983 4.629 8.041 7.692 10.064l.53.352a.5.5 0 0 0 .554 0l.53-.352c3.063-2.023 7.692-5.081 7.692-10.064C20.5 6.313 16.687 2.5 12 2.5m3.434 8.354C14.978 13.167 12 14.5 12 14.5s-2.978-1.333-3.434-3.646c-.28-1.419.332-2.847 1.887-2.854C11.611 7.995 12 9.143 12 9.143S12.389 7.995 13.547 8c1.559.007 2.167 1.435 1.887 2.854"
})));
export default SvgLocationHeartFill;